export default function TextField(theme) {
  return {
    MuiTextField: {
      defaultProps: {
        variant: 'outlined',
      },
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: theme.shape.borderRadius,
            '&:hover fieldset': {
              borderColor: theme.palette.primary.main,
            },
            '&.Mui-focused fieldset': {
              borderColor: theme.palette.primary.main,
              borderWidth: 2,
            },
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '&.MuiOutlinedInput-backdropFilter': {
            backgroundColor: 'rgba(248, 250, 252, 0.8)',
            border: '1px solid rgba(226, 232, 240, 0.3)',
            backdropFilter: 'blur(10px)',
            '& fieldset': {
              border: '1px solid transparent',
            },
            '&:hover fieldset': {
              border: '1px solid rgba(99, 102, 241, 0.2)',
            },
            '&.Mui-focused fieldset': {
              border: '1px solid rgba(99, 102, 241, 0.3)',
            },
            '&:hover': {
              backgroundColor: 'rgba(248, 250, 252, 0.9)',
              boxShadow: '0 2px 8px rgba(99, 102, 241, 0.1)',
            },
            '&.Mui-focused': {
              backgroundColor: 'rgba(255, 255, 255, 0.95)',
              boxShadow: '0 4px 20px rgba(99, 102, 241, 0.15)',
            },
          },
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        root: {
          '&:before': {
            borderBottomColor: theme.palette.grey[300],
          },
          '&:hover:not(.Mui-disabled):before': {
            borderBottomColor: theme.palette.primary.main,
          },
        },
        underline: {
          '&:after': {
            borderBottomColor: theme.palette.primary.main,
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          borderRadius: theme.shape.borderRadius,
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          '&.Mui-focused': {
            color: theme.palette.primary.main,
          },
        },
      },
    },
  };
}

